import { IOrganizationUser, USER_STATUS } from "@home-health-notify/domain";
import {
  Chip,
  Divider,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import { stringAvatar } from "hhn-commons";
import React from "react";
import { useNavigate } from "react-router";
import { Counter } from "../common/Common.style";
import { ROUTES } from "../routes";
import theme from "../theme";
import { AvatarStyle } from "./OrganizationList.style";
import { storeOrganizationId } from "../utils/organizationIdStorage";

export function OrganizationListItem({
  orgUser,
}: {
  orgUser: IOrganizationUser;
}) {
  const navigate = useNavigate();
  const org = orgUser.getOrganization();
  const onOrgClick = async () => {
    storeOrganizationId(org.organizationId);
    navigate(`${org.organizationId}/${ROUTES.CHATS}`);
  };
  const canAllowOrg = !orgUser.isOrganizationActive();
  return (
    <React.Fragment key={org.organizationId}>
      <ListItem alignItems="flex-start" data-testid="orgItem" disablePadding>
        <ListItemButton
          onClick={onOrgClick}
          disabled={
            canAllowOrg || org.userProfile.status !== USER_STATUS.ACTIVE
          }
        >
          <ListItemAvatar>
            <AvatarStyle>{stringAvatar(org.organizationName)}</AvatarStyle>
          </ListItemAvatar>
          <ListItemText
            primary={org.organizationName}
            secondary={
              <Typography
                component="span"
                variant="body2"
                sx={{
                  color: "text.primary",
                  display: "block"
                }}>
                {org.userProfile.firstName} {org.userProfile.lastName}
              </Typography>
            }
            slotProps={{
              secondary: {
                component: "div",
              }
            }}
          />
          {canAllowOrg && (
            <Chip sx={{ marginTop: "5px" }} size="small" label="Expired" />
          )}
          {org.userProfile.status !== USER_STATUS.ACTIVE && (
            <Chip sx={{ marginTop: "5px" }} size="small" label="Blocked" />
          )}
          {org.unreadAlertCount ? (
            <Counter backgroundColor={theme.palette.error.main}>
              {org.unreadAlertCount}
            </Counter>
          ) : null}
        </ListItemButton>
      </ListItem>
      <Divider variant="inset" component="li" />
    </React.Fragment>
  );
}
